import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'fr', // Force French on first load
    fallbackLng: 'fr', // Fallback to French
    debug: false,
    interpolation: {
      escapeValue: false
    },
    resources: {
      fr: {
        translation: require('./locales/fr/translation.json')
      },
      ar: {
        translation: require('./locales/ar/translation.json')
      }
    },
    detection: {
      // Configure detection behavior
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'], 
      lookupLocalStorage: 'i18nextLng',
    },
  });

export default i18n;
